import { getColumns, uniqueName } from './ValidationHomePage.Grid';
import appRoutes from '../../../infrastructure/constants/appRoutes';
import history from '../../../infrastructure/helpers/react/history';
import React from 'react';
import ServerDataGrid from '../../Common/DataGrid/ServerDataGrid/ServerDataGrid';
import urlHelper from '../../../infrastructure/helpers/common/urlHelper';
import DownloadModal from '../../Common/Modals/DownloadModal/DownloadModal';
import httpClient from '../../../infrastructure/helpers/common/httpClient';
import reportConfigBundleSerializer from '../../../infrastructure/helpers/report/import/reportConfigBundleSerializer';
import { getReportDataSources, getReportFields } from '../../Report/Pages/ReportPage/ReportPage.Helpers';
import { getConfigDataSources } from '../../Report/Import/ServerCalls';
import dataSourceKind from '../../../infrastructure/constants/dataSourceKind';
import ReportConfig from '../../../types/report/ReportConfig';
import actions from '../../../store/actions';
import store from '../../../store/store';
import ImportReportConfigModal from '../../Common/Modals/ImportReportConfigModal/ImportReportConfigModal';
import { Unsubscribe } from 'redux';
import GridRefresh from '../../../store/state/events/GridRefresh';
import ValidationConfigGridItem from '../../../types/report/ValidationConfigGridItem';
import messageHelper from '../../Common/Message/MessageHelper';
import copyObject from '../../../infrastructure/helpers/common/copyObject';

class ValidationHomePage extends React.Component<any, { reportConfigId: number, showDownloadPopup: boolean, showSpinnerForId: number, currentConfigInfo: ValidationConfigGridItem }>  {
    private unsubscribe: Unsubscribe | undefined;

    constructor(props: any) {
        super(props);

        this.state = {
            reportConfigId: 0,
            showDownloadPopup: false,
            showSpinnerForId: 0,
            currentConfigInfo: {} as ValidationConfigGridItem
        }

        this.onDownloadClick = this.onDownloadClick.bind(this);
        this.onDownloadTypesSelected = this.onDownloadTypesSelected.bind(this);
        this.onCopyConfigSourceClick = this.onCopyConfigSourceClick.bind(this);
        this.refreshGridListener = this.refreshGridListener.bind(this);
        this.onMouseLeaveDerscription = this.onMouseLeaveDerscription.bind(this);
    }

    componentDidMount(): void {
        this.unsubscribe = store.subscribe(this.refreshGridListener);
    }

    componentWillUnmount(): void {
        (this.unsubscribe as Unsubscribe)();
    }

    refreshGridListener(): void {

        let state = store.getState();

        let proceed =
            state.action === actions.copyReportConfigModal.saveSuccess ||
            state.action === actions.importReportConfigModal.saveSuccess;

        if (!proceed) {
            return;
        }

        this.refreshGrid();
    }

    refreshGrid(): void {

        let payload: GridRefresh = {
            uniqueName: uniqueName,
            useCurrentPage: false
        };

        store.dispatch({ type: actions.grid.refresh, payload: payload });
    }

    onEditClick(id: number): void {

        let route = urlHelper.buildUrl(appRoutes.validation.edit, { id: id });

        history.push(route);
    }

    onViewReleasedClick(id: number): void {

        let route = urlHelper.buildUrl(appRoutes.validation.edit, { id: id, released: true });

        history.push(route);
    }

    onDownloadClick(id: number): Promise<void> {

        this.setState({ showDownloadPopup: true, reportConfigId: id });
        return Promise.resolve();
    }

    onDownloadTypesSelected(downloadAsFragmented: boolean, useReleasedConfig: boolean): Promise<void> {

        this.setState({ showDownloadPopup: false });
        let route = urlHelper.buildRoute(['report', this.state.reportConfigId, downloadAsFragmented ? 'validation-export-fragmented' : 'validation-export-full', useReleasedConfig]);

        return httpClient.download(route);
    }

    onImportClick() {

        store.dispatch({ type: actions.importReportConfigModal.open, payload: null as any });
    }

    async onCopyConfigSourceClick(id: number): Promise<void> {

        this.setState({ showSpinnerForId: id });

        let url = 'report/' + id;

        var response = await httpClient.get<ReportConfig>(url);

        let res = await getReportDataSources(response.data);

        let dataSources = await getConfigDataSources(res.data.filter(x => x.dataSourceKind !== dataSourceKind.globalRef).map(x => x.id as number),
            res.data.filter(x => x.dataSourceKind === dataSourceKind.globalRef).map(x => x.id as number)
        );

        let reportFields = (await getReportFields(response.data)).data;

        let json = reportConfigBundleSerializer.serialize(response.data, dataSources, reportFields);

        await navigator.clipboard.writeText(json);

        this.setState({ showSpinnerForId: 0 });
    }

    async onMouseLeaveDerscription(gridInfo: ValidationConfigGridItem, description: string) {

        if (this.state.currentConfigInfo.id !== gridInfo.id && description && gridInfo.description?.trim() !== description?.trim()) {

            gridInfo.description = description;

            let url = urlHelper.buildRoute(['report', 'update', 'description']);

            await httpClient.put(url, gridInfo);

            messageHelper.showMesage(`Description "${description}" for config with Id: ${gridInfo.id} was saved.`, false, true);

            let config = copyObject(gridInfo);

            config.description = description;

            this.setState({ currentConfigInfo: config });
        }
    }

    render(): JSX.Element {
        return (
            <>
                <h3>Validation Configs</h3>
                <button type="button" className="btn cb-btn margin-bottom-70px" onClick={this.onImportClick}>Import Validation Config</button>
                <ServerDataGrid
                    columns={getColumns(this.onEditClick, this.onViewReleasedClick, this.onDownloadClick, this.onCopyConfigSourceClick, this.state.showSpinnerForId, this.onMouseLeaveDerscription)}
                    uniqueName={uniqueName}
                    dataSourceRoute="report/validation-page"
                    pageSize={10}
                    getKey={x => x.id} />
                <DownloadModal
                    onClose={() => { this.setState({ showDownloadPopup: false }) }}
                    onDownload={this.onDownloadTypesSelected}
                    isOpen={this.state.showDownloadPopup}
                    showVersionSelection={true} />
                <ImportReportConfigModal
                    isValidationConfig={true}
                    title="Import Validation Config"
                    skipDataSourcesValidation={true}/>
            </>
        );
    }
}

export default ValidationHomePage;
